import bem from 'utils/bem';

export const block = bem('full-length-template-compatibility');
